import type MathsReportingTimeOnTaskRoute from 'teacher-ui-client/reporting/ui-scope/maths/time-on-task/route'
import { ReportingTeacherUiHeader } from 'teacher-ui-client/components/reporting/teacher-ui-header'
import { ReportingDetailedControls } from 'teacher-ui-client/components/reporting/detailed-controls'
import { ReportingNoDataMessageIf } from 'teacher-ui-client/components/reporting/no-data-message-if'
import { ContentTile } from 'teacher-ui-client/components/tiles/content'
import { TimeOnTaskUsage } from 'teacher-ui-client/components/giraffe/charts/time-on-task/usage'
import { not } from 'ember-truth-helpers'
import { array } from '@ember/helper'
import { t } from 'ember-intl'
import { ExportType } from 'teacher-ui-client/components/reporting/export-select'
import { TimeOnTaskTable } from 'teacher-ui-client/components/tables/time-on-task'
import IsSubco from 'teacher-ui-client/helpers/is-subco'
import { ThemeKeys } from 'teacher-ui-client/utils/themes'
import RouteTemplate from 'ember-route-template'
import type { TOC } from '@ember/component/template-only'
import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'

interface Signature {
  Args: {
    model: ModelFor<MathsReportingTimeOnTaskRoute>
  }
}

export const ReportingUiScopeMathsTimeOnTaskPage: TOC<Signature> = <template>
  <ReportingTeacherUiHeader @title={{t "reporting.pageTitles.timeOnTaskUsage"}} />
  <ReportingDetailedControls
    @students={{@model.students}}
    @exportOptions={{array ExportType.CSV ExportType.print}}
    @isDataPresent={{Boolean @model.timeOnTaskUsage}}
    @showScopePicker={{true}}
    @showDatePicker={{true}}
    @studentRouteName="reporting.ui-scope.maths.student-summary.table"
  />
  <ReportingNoDataMessageIf @on={{not @model.timeOnTaskUsage}}>
    <ContentTile class="p-3">
      {{#if @model.timeOnTaskUsage}}
        <TimeOnTaskUsage
          data-test-time-on-task-usage-chart
          @data={{@model.timeOnTaskUsage}}
          @uiScope={{@model.uiScope}}
          @primaryTheme={{ThemeKeys.green}}
          @secondaryTheme={{ThemeKeys.orange}}
        />
      {{/if}}
    </ContentTile>
    <ContentTile class="mt-4 print:border-none">
      {{#if @model.timeOnTaskHistory}}
        <TimeOnTaskTable
          class="overflow-x-auto"
          @students={{@model.students}}
          @data={{@model.timeOnTaskHistory}}
          @isSubco={{(IsSubco)}}
          @subscriptionType={{SubscriptionType.Maths}}
        />
      {{/if}}
    </ContentTile>
  </ReportingNoDataMessageIf>
</template>

export default RouteTemplate(ReportingUiScopeMathsTimeOnTaskPage)
